export class PreviewBackupPolicyResourcesRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "condition",
            "baseName": "condition",
            "type": "Condition",
            "format": ""
        },
        {
            "name": "include",
            "baseName": "include",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "exclude",
            "baseName": "exclude",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "policyType",
            "baseName": "policyType",
            "type": "BackupPolicyType",
            "format": ""
        },
        {
            "name": "resourceTypes",
            "baseName": "resourceTypes",
            "type": "Array<ResourceType>",
            "format": ""
        },
        {
            "name": "schedules",
            "baseName": "schedules",
            "type": "Array<CreatePolicyScheduleInput>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PreviewBackupPolicyResourcesRequest.attributeTypeMap;
    }
    constructor() {
    }
}
